import { useAuth } from './useAuth';
import { useRoleContext } from './useRoleContext';

const usePermissions = () => {
  const { permissions } = useAuth();

  const hasPermission = (permission: any, systemRole: any) => {
    if ((systemRole === 'admin' || systemRole === 'marcom') && !['upload_final_version_with_changes', 'action_change_status'].includes(permission)) {
      return true;
    }

    const userPermissions = permissions[systemRole] || [];
    return userPermissions.includes(permission);
  };

  const hasAIPrivileges = (privilege: any) => {
    if (privilege === 'admin') {
      return true;
    }

    return false;
  };

  /*
  const hasWorkflowPermission = (permission: any, workflowRole: any, systemRole: any) => {
    if (systemRole === 'admin') {
      return true;
    }
    
    const userPermissions = workflowPermissions[workflowRole] || [];
    return userPermissions.includes(permission);
  };
  */

  return {
    hasPermission,
    hasAIPrivileges,
    // hasWorkflowPermission
  };
};

export default usePermissions;
